<template>
  <span>
    <span :id="`${field.key}-select-filter`" size="sm">
      <i class="ri ri-filter-2-fill"></i
    ></span>
    <b-popover :target="`${field.key}-select-filter`" triggers="hover focus">
      <b-form-group>
        <b-form-checkbox-group
          :checked="field.filter.value"
          :options="field.filter.items"
          :name="`${field.key}-select-filter`"
          @input="$emit('input', $event)"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-popover>
  </span>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
}
</script>
